import { muiStyles } from 'utils/design';

export const useStyles = muiStyles((theme) => ({
  searchIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.grey['600'],
  },
}));
